import React from 'react';
import { NodeViewWrapper } from '@tiptap/react';
import { Type, Hash, ToggleRight, Braces, Brackets } from 'lucide-react';

const dataTypeIcons = {
    string: <Type size={14} className="mr-1.5 opacity-80 flex-shrink-0" />,
    number: <Hash size={14} className="mr-1.5 opacity-80 flex-shrink-0" />,
    boolean: <ToggleRight size={14} className="mr-1.5 opacity-80 flex-shrink-0" />,
    object: <Braces size={14} className="mr-1.5 opacity-80 flex-shrink-0" />,
    array: <Brackets size={14} className="mr-1.5 opacity-80 flex-shrink-0" />,
};

const VariablePill = ({ node }) => {
    const { display, dataType } = node.attrs;
    const icon = dataTypeIcons[dataType?.toLowerCase()] || dataTypeIcons.string;

    return (
        <NodeViewWrapper
            as="span"
            // ⭐ THE FIX: Adjusted padding, using a border, and ensuring vertical alignment.
            className="inline-flex items-center align-middle bg-indigo-500/30 text-indigo-300 border border-indigo-500/50 rounded-md px-2 py-0 mx-0.5 text-sm font-mono select-none"
        >
            {icon}
            <span className="truncate">{display}</span>
        </NodeViewWrapper>
    );
};

export default VariablePill;